export default import.meta.ROLLDOWN_FILE_URL_Xx$EHp0H3yxQJFU0th7n8Q